import React, { useState } from "react";
import ExpandableSection from "../../../../../components/ExpandableSection";
import MoveEntityTable from "./MoveEntityTable";

export default function MoveEntitySection(props) {

  var {
    title,
    columns,
    rows,
    availableRows,
    onAddEntities
  } = props;

  var [drawerOpen, setDrawerOpen] = useState(false);
  var [selectedIds, setSelectedIds] = useState([]);
  var [searchText, setSearchText] = useState("");

  function openDrawer() {
    setSelectedIds([]);
    setSearchText("");
    setDrawerOpen(true);
  }

  function closeDrawer() {
    setDrawerOpen(false);
  }

  function confirmAdd() {
    if (onAddEntities) {
      onAddEntities(selectedIds);
    }
    setDrawerOpen(false);
  }

  function filterRows(rows) {
    if (!searchText) {
      return rows;
    }

    return rows.filter(function (row) {
      return JSON.stringify(row)
        .toLowerCase()
        .indexOf(searchText.toLowerCase()) !== -1;
    });
  }
  
  

  return (
    <div>

      {/* MAIN SECTION */}
      <ExpandableSection title={title} 	  buttonLabel="Add"
	    onButtonClick={openDrawer}>

        <MoveEntityTable
          columns={columns}
          rows={rows}
        />

      </ExpandableSection>

      {/* RIGHT-HAND DRAWER */}
	  <div
	    style={{
	      ...styles.drawerBackdrop,
	      pointerEvents: drawerOpen ? "auto" : "none",
	      opacity: drawerOpen ? 1 : 0
	    }}
	  >

	  <div
	    style={{
	      ...styles.drawer,
	      transform: drawerOpen ? "translateX(0)" : "translateX(100%)"
	    }}
	  >

            {/* HEADER */}
            <div style={styles.drawerHeader}>
              <div style={styles.drawerTitle}>
                Add {title}
              </div>
              <div style={styles.drawerClose} onClick={closeDrawer}>
                ✕
              </div>
            </div>

            {/* SEARCH */}
            <div style={styles.search}>
              <input
                type="text"
                placeholder="Search…"
                value={searchText}
                onChange={function (e) {
                  setSearchText(e.target.value);
                }}
                style={styles.searchInput}
              />
            </div>

            {/* TABLE */}
            <div style={styles.drawerBody}>
              <MoveEntityTable
                columns={columns}
                rows={filterRows(availableRows)}
                selectable={true}
                selectedIds={selectedIds}
                onSelectionChange={setSelectedIds}
              />
            </div>

            {/* FOOTER */}
            <div style={styles.drawerFooter}>
              <button style={styles.cancel} onClick={closeDrawer}>
                Cancel
              </button>

              <button
                style={styles.confirm}
                disabled={selectedIds.length === 0}
                onClick={confirmAdd}
              >
                Add selected ({selectedIds.length})
              </button>
            </div>

          </div>
        </div>
     

    </div>
  );
}

const styles = {

	drawerBackdrop: {
	    position: "fixed",
	    inset: 0,
	    background: "rgba(0,0,0,0.25)",
	    zIndex: 200000,
	    transition: "opacity 0.25s ease"
	  },

	  drawer: {
	    position: "absolute",
	    top: 0,
	    right: 0,
	    width: "1020px",
	    height: "100%",
	    background: "#ffffff",
	    boxShadow: "-10px 0 25px rgba(0,0,0,0.35)",
	    display: "flex",
	    flexDirection: "column",

	    /* ✨ animation */
	    transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
	  },

  drawerHeader: {
    padding: "16px 20px",
    borderBottom: "1px solid #e6e6e6",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
	background:'linear-gradient(180deg, #2F80ED 0%, #1C5FD4 100%)',
	
  },

  drawerTitle: {
    fontSize: "16px",
    fontWeight: 600,
	color:'white'
  },

  drawerClose: {
    cursor: "pointer",
    fontSize: "18px",
	color:'white'
  },

  search: {
    padding: "12px 20px",
    borderBottom: "1px solid #eee"
  },

  searchInput: {
    width: "100%",
    padding: "8px",
    fontSize: "13px"
  },

  drawerBody: {
    flex: 1,
    overflowY: "auto"
  },

  drawerFooter: {
    padding: "12px 20px",
    borderTop: "1px solid #e6e6e6",
    display: "flex",
    justifyContent: "space-between"
  },

  cancel: {
    background: "#eee",
    border: "none",
    padding: "8px 14px",
    cursor: "pointer"
  },

  confirm: {
    background: "#2F80ED",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    cursor: "pointer",
	background:'linear-gradient(180deg, #2F80ED 0%, #1C5FD4 100%)',
	borderRadius:'7px',
	boxShadow: '0 2px 6px rgba(0, 0, 0, 0.18)'
  }
};
